import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Select } from 'foundations-components/transitional/components/Select';
import { INITIAL_POPULAR_COUNT } from '../constants/find-partner-match';
import { useFindPartnerMatch } from '../hooks/useFindPartnerMatch';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function FindPartnerMatch({
  onClose
}) {
  const {
    step,
    setStep,
    selectedService,
    setSelectedService,
    selectedIndustries,
    setSelectedIndustries,
    showMore,
    setShowMore,
    partnerCount,
    serviceOptions,
    allPopularServices,
    popularServices,
    industryOptions,
    popularIndustries,
    handleNext,
    handleSkip
  } = useFindPartnerMatch(onClose);
  return /*#__PURE__*/_jsxs(Modal, {
    width: 700,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: partnerCount > 0 && /*#__PURE__*/_jsx(FormattedMessage, {
        message: partnerCount > 1 ? 'marketplaceStorefront.hero.solutions.findPartnerMatch.matchingPartners.other' : 'marketplaceStorefront.hero.solutions.findPartnerMatch.matchingPartners.one',
        options: {
          partnerCount
        }
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: step === 1 ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.hero.solutions.findPartnerMatch.service.title"
          })
        }), /*#__PURE__*/_jsx(Select, {
          options: serviceOptions,
          placeholder: unescapedText('marketplaceStorefront.hero.solutions.findPartnerMatch.service.placeholder'),
          onChange: ({
            target: {
              value
            }
          }) => setSelectedService(value),
          value: selectedService !== null && selectedService !== void 0 ? selectedService : undefined
        }), !!popularServices.length && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(H4, {
            marginBlockStart: "700",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.hero.solutions.findPartnerMatch.popularServices"
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            flexWrap: "wrap",
            gap: "200",
            children: [popularServices.map(service => /*#__PURE__*/_jsxs(Button, {
              margin: "0",
              onClick: () => setSelectedService(service.value),
              size: "small",
              use: "tertiary",
              children: ["+ ", service.text]
            }, service.value)), !showMore && allPopularServices.length > INITIAL_POPULAR_COUNT && /*#__PURE__*/_jsx(Button, {
              margin: "0",
              onClick: () => setShowMore(true),
              size: "small",
              use: "transparent",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceStorefront.hero.solutions.findPartnerMatch.seeMore"
              })
            })]
          })]
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.hero.solutions.findPartnerMatch.industry.title"
          })
        }), /*#__PURE__*/_jsx(Select, {
          multi: true,
          options: industryOptions,
          placeholder: unescapedText('marketplaceStorefront.hero.solutions.findPartnerMatch.industry.placeholder'),
          onChange: ({
            target: {
              value
            }
          }) => setSelectedIndustries(value !== null && value !== void 0 ? value : []),
          value: selectedIndustries
        }), !!popularIndustries.length && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(H4, {
            marginBlockStart: "700",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.hero.solutions.findPartnerMatch.topIndustries"
            })
          }), /*#__PURE__*/_jsx(Flex, {
            flexWrap: "wrap",
            gap: "200",
            children: popularIndustries.map(industry => /*#__PURE__*/_jsxs(Button, {
              margin: "0",
              onClick: () => setSelectedIndustries(prev => [...prev, industry.value]),
              size: "small",
              use: "tertiary",
              children: ["+ ", industry.text]
            }, industry.value))
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      align: "between",
      children: [step === 1 ? /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        size: "medium",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.hero.solutions.findPartnerMatch.closeButton"
        })
      }) : /*#__PURE__*/_jsx(Button, {
        onClick: () => setStep(1),
        size: "medium",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.hero.solutions.findPartnerMatch.backButton"
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        gap: "300",
        alignItems: "center",
        children: [step === 2 && /*#__PURE__*/_jsx(Button, {
          margin: "0",
          onClick: handleSkip,
          use: "transparent",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.hero.solutions.findPartnerMatch.skipButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: step === 1 && !selectedService,
          margin: "0",
          onClick: handleNext,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.hero.solutions.findPartnerMatch.nextButton"
          })
        })]
      })]
    })]
  });
}